import axios from "infra/http";
import { useMutation } from "react-query";
import { ArrecadacaoAutomaticaParametrosForm } from "./typings";

function useSalvarParametrosArrecadacaoAutomatica() {
  return useMutation((form: ArrecadacaoAutomaticaParametrosForm) => {
    return axios.put(`/v1/arrecadacao/parametros-arrecadacao-automatica`, form);
  });
}

export default useSalvarParametrosArrecadacaoAutomatica;
